<template>
  <div class="homePage">
    <div class="homebg">
      <img src="../assets/sharedHome/share_bg1.png" alt />
    </div>
    <div class="bigBg">
      <div class="publicBox">
        <div class="yellowArticle center">
          <img src="../assets/sharedHome/share_title1.png" alt />
        </div>
        <div class="publicWhiteBox">
          <div v-if="!getCouponTrue">
            <div class="couponList" v-for="(item,index) in tickets" :key="index">
              <img src="../assets/sharedHome/share_coupon.png" alt class="couponBgImg" />
              <div class="couponView box">
                <div class="couponLeft box_c" v-if="item.rule_type==1">
                  <div class="couponNumBox">
                    <span>{{item.face_val}}</span>折
                  </div>
                </div>
                <div class="couponLeft box_c" v-else-if="item.rule_type==2 || item.rule_type==4">
                  <div class="couponNumBox">
                   ¥<span>{{item.face_val}}</span>
                  </div>
                </div>
                <div class="couponLeft box_c" v-else-if="item.rule_type==3 || item.rule_type==6">
                  <div class="couponNumBox">
                    <span>{{item.face_val}}</span>天
                  </div>
                </div>
                <div class="couponRight box_h">
                  <div>
                    <div class="couponName">{{item.title}}</div>
                    <div class="couponCondition">{{item.describe}}</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="couponHint txt">优惠券领取日开始半年内有效，请及时使用</div> -->
            <div class="getCouponBox">
              <div class="getBtn box_c" v-if="!hasCoupon" @click="getCoupon">
                <!-- <span>立即领取</span> -->
                <!-- <img src="../assets/sharedHome/share_receive.png" alt=""> -->
              </div>
              <div class="notGetBtn box_c" v-else>已领取</div>
            </div>
          </div>
        </div>
      </div>

      <div class="publicBox">
        <div class="yellowArticle center">
          <img src="../assets/sharedHome/share_title2.png" alt />
        </div>
        <div class="publicWhiteBox" style="padding:18px 40px">
          <div class="box_cqh listBox">
            <div class="step">
              <div class="imgView">
                <div class="imgs">
                  <img src="../assets/sharedHome/share_ic1.png" alt />
                </div>
              </div>
              <div class="imgViewBottom box">
                <div class="num">01</div>
                <div class="stepTxt">
                  <div>手机扫码,</div>
                  <div>选择机器</div>
                </div>
              </div>
            </div>

            <div class="step">
              <div class="arrow">
                <img src="../assets/sharedHome/share_arrow_left.png" alt />
              </div>
            </div>

            <div class="step">
              <div class="imgView">
                <div class="imgs">
                  <img src="../assets/sharedHome/share_ic2.png" alt />
                </div>
              </div>
              <div class="imgViewBottom box">
                <div class="num">02</div>
                <div class="stepTxt">
                  <div>手机下单,</div>
                  <div>柜门打开</div>
                </div>
              </div>
            </div>
          </div>
          <div class="listBox listRight">
            <div class="step">
              <div class="arrow">
                <img src="../assets/sharedHome/share_arrow_down.png" alt />
              </div>
            </div>
          </div>
          <div class="box_cqh listBox">
            <div class="step">
              <div class="imgView">
                <div class="imgs">
                  <img src="../assets/sharedHome/share_ic4.png" alt />
                </div>
              </div>
              <div class="imgViewBottom box">
                <div class="num">04</div>
                <div class="stepTxt">
                  <div>扫码归还,</div>
                  <div>关闭柜门</div>
                </div>
              </div>
            </div>

            <div class="step">
              <div class="arrow">
                <img src="../assets/sharedHome/share_arrow_left.png" class="spinImg" alt />
              </div>
            </div>

            <div class="step">
              <div class="imgView">
                <div class="imgs">
                  <img src="../assets/sharedHome/share_ic3.png" alt />
                </div>
              </div>
              <div class="imgViewBottom box">
                <div class="num">03</div>
                <div class="stepTxt">
                  <div>取走机器,</div>
                  <div>关闭柜门</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="publicBox">
        <div class="publicWhiteBox">
          <div class="codeBox box_cqh">
            <div class="codeLeft">
              <div class="title">关注公众号获取更多资讯</div>
              <div class="titleHint">
                <span>长按识别二维码</span>
                <img src="../assets/sharedHome/share_arrow1.png" alt />
                <img src="../assets/sharedHome/share_arrow2.png" alt />
              </div>
            </div>
            <div class="codeRight">
              <img src="../assets/sharedHome/share_offical.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swipe, SwipeItem, Toast } from "vant";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import { Carousel3d, Slide } from "vue-carousel-3d";
import "swiper/css/swiper.css";
import qs from "qs";
// var vConsole = new VConsole();
let isAli = "";
export default {
  components: {
    Swiper,
    SwiperSlide,
    Carousel3d,
    Slide,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      hasCoupon: false, //是否已经领取优惠券
      miniProgram: false,
      getCouponTrue: false, //是否领取成功
      token: "",
      tickets: [], //优惠券列表
      isRequest: true,
      slideIndex: 0,
      swiperOptions: {
        autoplay: true,
        loop: true,
        effect: "coverflow",
        slidesPerView: 2,
        centeredSlides: true,
        coverflowEffect: {
          rotate: 20,
          stretch: 10,
          depth: 80,
          modifier: 1,
          slideShadows: true,
        },
        // Some Swiper option/callback...
      },
    };
  },
  computed: {},
  methods: {
    couponStatus() {
      this.$get("user_ticket/index?activity_name=share").then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.hasCoupon = res.data.status;
          this.tickets = res.data.tickets;
        }
      });
    },
    getCoupon() {
      this.$router.push("/sharedGetCoupon");
    },
    onSwiperSlideChangeTransitionStart() {
      console.log(index);
    },

    initWxapi() {
      this.$get("wechat/share?url=" + window.location.href).then((res) => {
        console.log(res);
      });
    },
    change(index) {
      // console.log(index)
      this.slideIndex = index;
    },
  },
  mounted() {
    let that = this;
    // 引入微信分享封装函数
    that.wxApi.wxRegister();
    that.couponStatus();
  },
};
</script>

<style scoped lang='scss'>
@import "../common/font/font.css";
.homePage {
  width: 100%;
  min-height: 100vh;
  overflow-y: auto;
  // padding-top: 170px;
  background-size: 100%;
  background-color: #0084ff;
  .swiper-container {
    width: 100%;
    height: 115px;
  }
  .homebg {
    width: 100%;
    img {
      width: 100%;
    }
  }
  .bigBg {
    position: relative;
    top: -47px;
  }
  .publicBox {
    width: 100%;
    padding: 0 11px;
    box-sizing: border-box;
    margin-bottom: 20px;
    .yellowArticle {
      width: 100%;
      text-align: center;
      font-size: 0;
      img {
        width: 136px;
      }
    }
    .publicWhiteBox {
      width: calc(100% - 12px);
      margin: 0 auto;
      background: rgba(255, 255, 255, 1);
      border-radius: 5px;
      padding: 18px 15px;
      box-sizing: border-box;
      position: relative;
      // top: -30px;
      .publicTitleBox {
        width: 100%;
        font-size: 20px;
        font-family: Alibaba PuHuiTi;
        font-weight: bold;
        color: rgba(254, 36, 47, 1);
        margin-bottom: 25px;
        span {
          margin: 0 5px;
        }
        img {
          width: 14px;
        }
      }
      .couponList {
        width: 100%;
        position: relative;
        .couponBgImg {
          width: 100%;
        }
        .couponView {
          width: 100%;
          height: 100%;
          position: absolute;
          top: -7px;
          left: 0;
          .couponLeft {
            flex: 3;
            height: 100%;
            color: #ffffff;
            font-size: 12px;
            font-family: PingFang SC;
            padding-left: 10px;
            box-sizing: border-box;
            .couponNumBox {
              vertical-align: baseline;
            }
            span {
              font-size: 50px;
              // font-weight: bold;
              font-family: "number";
              // margin: 0 2px;
            }
          }
          .couponRight {
            flex: 7;
            height: 100%;
            padding-left: 20px;
            box-sizing: border-box;
            .couponName {
              font-size: 18px;
              font-family: PingFang SC;
              font-weight: bold;
              color: rgba(255, 255, 255, 1);
              margin-bottom: 10px;
            }
            .couponCondition {
              font-size: 12px;
              font-family: PingFang SC;
              // font-weight: 500;
              color: rgba(255, 255, 255, 1);
              text-align: left;
            }
          }
        }
      }
      .getCouponBox {
        width: 144px;
        height: 45px;
        margin: 10px auto;
        .getBtn {
          width: 100%;
          height: 100%;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          background: url("../assets/sharedHome/share_receive.png") no-repeat;
          background-size: 100%;
          padding-bottom: 10px;
          box-sizing: border-box;
        }
        .notGetBtn {
          width: 100%;
          height: 100%;
          background-color: #c6c6c6;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          background: url("../assets/sharedHome/share_received.png") no-repeat;
          background-size: 100%;
        }
      }
      .hasCouponBox {
        width: 100%;
        img {
          width: 87px;
          margin-bottom: 15px;
        }
        .successVlaue {
          font-size: 15px;
          font-family: PingFang SC;
          font-weight: bold;
          color: rgba(254, 36, 47, 1);
          margin-bottom: 20px;
        }
        .successHint {
          font-size: 11px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
        }
      }
      .couponHint {
        font-size: 13px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        margin-top: 15px;
      }
      .listBox {
        width: 100%;
        .step {
          .arrow {
            width: 20px;
            height: 20px;
            img {
              width: 20px;
              height: 20px;
            }
            .spinImg {
              transform: rotate(180deg);
            }
          }
          .imgView {
            .imgs {
              width: 90px;
              height: 90px;
              margin-bottom: 10px;
              img {
                width: 90px;
                height: 90px;
              }
            }
          }
          .imgViewBottom {
            .num {
              font-family: "number";
              color: #0084ff;
              font-size: 20px;
              margin-right: 4px;
            }
            .stepTxt {
              font-size: 13px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #999999;
            }
          }
        }
      }
      .listRight {
        display: flex;
        justify-content: flex-end;
        .step {
          margin-top: 7px;
          margin-bottom: 6px;
          .arrow {
            width: 90px;
            text-align: center;
          }
        }
      }
      .codeBox {
        width: 100%;
        .codeLeft {
          .title {
            font-size: 16px;
            font-family: Source Han Sans CN;
            color: #333333;
            margin-bottom: 15px;
          }
          .titleHint {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #666666;
            span {
              margin-right: 6px;
            }
            img {
              width: 5px;
              height: 8px;
              margin-right: 3px;
            }
          }
        }
        .codeRight{
          img{
            width: 89px;
            height: 89px;
          }
        }
      }
    }

    .bannerBox {
      width: 100%;
      margin-bottom: 15px;
      .imgList {
        // margin: 0 auto;
        // width: 80%;
        // height: 135px;
        img {
          width: 100%;
          // border-radius: 5px;
          // height: 100%;
          // object-fit: cover;
        }
      }
      .desc {
        width: 100%;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(153, 153, 153, 1);
      }
    }
    /* 租赁推荐 */
    .recBox {
      width: 100%;
    }
    .recList {
      width: 100%;
      margin-bottom: 14px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 3px 3px 0px rgba(172, 172, 172, 0.35);
      border-radius: 5px;
    }
    .listImg {
      width: 130px;
      height: 130px;
      background: rgba(243, 243, 243, 1);
      border-radius: 4px;
    }
    .listImg img {
      width: 100%;
    }
    .listInfo {
      width: 209px;
      height: 100%;
      padding: 16px 10px;
      box-sizing: border-box;
      padding-bottom: 0px;
    }
    .listName {
      font-size: 14px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      line-height: 18px;
      min-height: 36px;
      margin-bottom: 35px;
    }
    .sales {
      font-size: 11px;
      font-weight: bold;
      color: rgba(153, 153, 153, 1);
    }
    .listPrice {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(255, 51, 51, 1);
      line-height: 17px;
    }
    .small {
      font-size: 13px;
      line-height: 13px;
    }
    .leaseBtn {
      width: 76px;
      height: 28px;
      background: rgba(255, 51, 51, 0.15);
      border-radius: 14px;
      font-size: 13px;
      font-weight: bold;
      color: rgba(255, 51, 61, 1);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/sharedHome.vue